import type { CSSProperties } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Ic from "../icons.jsx";

/**
 * Proizvodi | Kategorije switcher for catalog administration.
 *
 * The categories screen was fully built but nothing linked to it — the only way
 * in was typing /admin/catalog/categories by hand, so "add a category" looked
 * impossible from the UI. Same idiom as OffersViewSwitcher / LeadsViewSwitcher.
 */
export function CatalogAdminTabs({ active }: { active: "products" | "categories" }) {
  const { t } = useTranslation();
  return (
    <div style={row}>
      <Link
        to="/admin/catalog/products"
        className={active === "products" ? "btn primary sm" : "btn sm"}
        style={active !== "products" ? { textDecoration: "none" } : undefined}
      >
        <Ic.catalog /> {t("admin.catalog.tab.products", "Products")}
      </Link>
      <Link
        to="/admin/catalog/categories"
        className={active === "categories" ? "btn primary sm" : "btn sm"}
        style={active !== "categories" ? { textDecoration: "none" } : undefined}
      >
        <Ic.list /> {t("admin.catalog.tab.categories", "Categories")}
      </Link>
    </div>
  );
}

const row: CSSProperties = { display: "flex", gap: 6 };
